export default "__VITE_ASSET__L4H7R7V4__"